import { render } from "./CardDetailsPopup.vue?vue&type=template&id=4c259fe0&scoped=true"
import script from "./CardDetailsPopup.vue?vue&type=script&lang=js"
export * from "./CardDetailsPopup.vue?vue&type=script&lang=js"

import "./CardDetailsPopup.vue?vue&type=style&index=0&id=4c259fe0&lang=css"
import "./CardDetailsPopup.vue?vue&type=style&index=1&id=4c259fe0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c259fe0"]])

export default __exports__